import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export interface ScModalProps {
  bottom?: number;
}

export const ScModal = styled.div<ScModalProps>`
  top: 0;
  bottom: ${({ bottom }) => (bottom ? `${bottom}px` : '0')};
  left: 0;
  right: 0;
  z-index: 1043;
  position: fixed;
  outline: 0 !important;
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1120;
`;

export const ScModalBg = styled.div<ScModalProps>`
  top: 0;
  bottom: ${({ bottom }) => (bottom ? `${bottom}px` : '0')};
  left: 0;
  right: 0;
  z-index: -1;
  overflow: hidden;
  position: fixed;
  background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.8)};

  @media (${device.mobile}) {
    background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.95)};
  }
`;

export const ScModalContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  @media (${device.mobile}) {
    padding: 0;
  }
`;

export enum VerticalAlign {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}

export interface ScModalContentProps {
  verticalAlign?: VerticalAlign;
  fullHeight?: boolean;
  padding?: number;
}

export const ScModalContent = styled.div<ScModalContentProps>`
  position: relative;
  display: inline-block;
  vertical-align: ${({ verticalAlign }) =>
    verticalAlign == null ? VerticalAlign.MIDDLE : verticalAlign};
  padding: ${({ padding }) => (padding ? `${padding}px` : 0)};
  margin: 0 auto;
  text-align: left;
  z-index: 1042;
  width: 100%;
  cursor: auto;
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}
`;
